import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

interface Props {
  ajgaData: unknown | null;
  linked: boolean;
}

export function UserAJGASection({ ajgaData, linked }: Props) {
  const data = ajgaData as Record<string, unknown> | null;

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <CardTitle className="text-base">AJGA Data</CardTitle>
          <Badge
            variant="outline"
            className={
              linked
                ? "bg-green-100 text-green-800 border-green-200 text-xs"
                : "bg-gray-100 text-gray-600 border-gray-200 text-xs"
            }
          >
            {linked ? "Linked" : "Not Linked"}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        {!linked || !data ? (
          <p className="text-sm text-muted-foreground">Not linked to an AJGA profile.</p>
        ) : (
          <div className="space-y-2 text-sm">
            {data.ranking != null && (
              <div className="flex justify-between">
                <span className="text-muted-foreground">Ranking</span>
                <span>{String(data.ranking)}</span>
              </div>
            )}
            {data.points != null && (
              <div className="flex justify-between">
                <span className="text-muted-foreground">Points</span>
                <span>{String(data.points)}</span>
              </div>
            )}
            {data.ranking == null && data.points == null && (
              <p className="text-muted-foreground">Linked but no ranking data available.</p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
